
import { Component, Prop, Vue } from 'vue-property-decorator'

interface BreadcrumbItem {
  label: string;
  to?: string;
}

@Component
export default class Breadcrumb extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly items!: BreadcrumbItem[]
}
